let GWP = {
  running: false,
  GWPInCart: false,
  GWPRequired: false,
  GWPProductId: null,
  GWPCustomerTags: null,
  GWPCustomerExcludeTags: null,
  GWPItemKey: null,
  GWPItemQty: null,
  refresh: false,

  init: function (refresh=false) {
    this.refresh = refresh;
    if (!this.running) {
      this.running = true;
      fetch('/cart.js').then(res => res.json()).then(response => {
        this.checkCartForGWPProduct(response);
      });
    }
  },

  checkCartForGWPProduct: function (data) {
    if (
      data.item_count < 1 ||
      typeof data.items == "undefined" ||
      typeof window.gwp_settings == "undefined" ||
      typeof window.gwp_settings.product == "undefined" ||
      typeof window.gwp_settings.product.variants == "undefined"
    ) {
      if(this.refresh) {
        if ($('body').hasClass('template--cart') || $('body').hasClass('shopify-checkout')) location.reload();
      }
      this.running = false;
      return;
    }
    this.GWPInCart = false;
    this.GWPRequired = false;
    this.GWPProductId = null;
    this.GWPItemKey = null;
    this.GWPItemQty = null;

    let items = data.items;
    let _this = this;

    this.GWPProductId = window.gwp_settings.product.variants[0].id;
    this.GWPCustomerTags = window.gwp_settings.customer_tags.split(',');
    this.GWPCustomerExcludeTags = window.gwp_settings.customer_exclude_tags.split(',');

    let hasExcludeTag = false;
    this.GWPCustomerTags.forEach(function(tag) {
      _this.GWPCustomerExcludeTags.forEach(function(excludeTag) {
        if(excludeTag == tag) hasExcludeTag = true;
      });
    });

    if(data.original_total_price > (window.gwp_settings.threshold * 100)) {
      this.GWPRequired = true;
    }

    items.forEach(function (item) {
      items.forEach(function (GWPItem) {
        if(GWPItem.variant_id == _this.GWPProductId) {
          _this.GWPInCart = true;
          _this.GWPItemKey = GWPItem.key;
          _this.GWPItemQty = GWPItem.quantity;
        }
      });
    });

    if(hasExcludeTag) {
      if(this.GWPInCart) {
        _this.updateItemQty(_this.GWPItemKey, 0);
      }
      else this.running = false;
      return;
    }

    // add GWP product if required
    if(!_this.GWPInCart && _this.GWPRequired && _this.GWPProductId) {
      _this.addGWPProductToCart(_this.GWPProductId);
    }

    // remove GWP product if not required
    else if(_this.GWPInCart && !_this.GWPRequired && _this.GWPProductId){
      _this.updateItemQty(_this.GWPItemKey, 0);
    }

    // fix quantity if not 1
    else if (_this.GWPItemQty > 1) {
      _this.updateItemQty(_this.GWPItemKey);
    }

    else if(this.refresh) {
      this.exit();
    }

    else {
      this.running = false;
    }
  },

  addGWPProductToCart: function(id) {
    let _this = this;
    let data = {
      quantity: 1,
      id: id,
      properties: {
        '_is_GWP_product': true
      }
    };
    fetch('/cart/add.js', {
      'method': 'POST',
      'headers': {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    }).then(response => {
      _this.exit();
    });
  },

  updateItemQty: function(id,qty=1) {
    let _this = this;
    fetch('/cart/change.js', {
      'method': 'POST',
      'headers': {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({id: id, quantity: qty})
    }).then(response => {
      _this.exit();
    });
  },

  exit: function() {
    if ($('body').hasClass('template--cart') || $('body').hasClass('shopify-checkout')) location.reload();
    this.running = false;
  }

}

GWP.init();

document.addEventListener("cart:qty-changed", (e) => {
  GWP.init(true);
});